<template>
  <page-frame headStyle="height:2.12rem;" bodyStyle="top:2.12rem;">
    <header-bar slot="head" navStyle="padding-left:.266rem;padding-right:.266rem;">
      <span slot="left">{{ $t("mall_modules_editrole_fanhui") }}</span>
      <span>{{ $t(objSave.centerTitle) }}</span>
    </header-bar>

    <ProvisionalAuthorization :Companys="Companys" v-model="model">
      <div class="ProvisionalAuthorization-Btn">
        <div @click="Save">{{ $t("system_approvalset_list_baocun") }}</div>
      </div>
    </ProvisionalAuthorization>
    <div style="height:0.532rem;background-color: #f0f0f0"></div>
    <div class="AuthorizationList">
      <div class="AuthorizationList-title" style="position: relative;">
        <span>
          <img src="/static/img/AuthorizationListIcon.png" style="width:0.399rem;vertical-align: middle" />
          <a style="vertical-align: middle">{{ $t("system_approvalset_list_shouquanliebiao") }}</a>
        </span>
        <span @click="clearExpiryDate">{{ $t("system_approvalset_list_yijianqingchu") }}</span>
      </div>
      <Scroll ref="scroll" :data="lists">
        <ul class="content">
          <li>
            <div class="AuthorizationList-wrapper" v-for="(list, index) in lists" :key="index">
              <div class="AuthorizationList-item" v-if="list.OwnerID == Company.RoleID" v-for="Company in Companys" :key="Company.RoleID">
                <div @click="editApprovalSet(list.ConferID)">
                  <div class="AuthorizationList-tag">
                    <span class="ellipsis">{{ Company.RoleName }}</span>
                    <span class="ellipsis" v-if="isExpiryDate(list.ExpiryDate)" :class="{ isExpiryDate: isExpiryDate(list.ExpiryDate) }">{{ $t("system_approvalset_list_yiguoqi") }}</span>
                    <span v-else>{{ $t("system_approvalset_list_shouquanzhong") }}</span>
                  </div>
                </div>
                <div style="padding:0 0.399rem;height:100%;" @click="delectApprovalSet(list.ConferID)">
                  <img src="/static/img/delect1.png" style="width:0.399rem;vertical-align: middle" />
                </div>
              </div>
              <div class="border_bottom"></div>
            </div>
          </li>
        </ul>
      </Scroll>
    </div>
    <div class="ProvisionalAuthorization-popOut">
      <transition name="picker-fade">
        <div class="picker" v-show="state === 1" @touchmove.prevent @click="cancel">
          <transition name="picker-move">
            <div class="picker-panel" v-if="state === 1" @click.stop>
              <div class="picker-content">
                <ProvisionalAuthorization :Companys="Companys" v-model="detailModel">
                  <div class="ProvisionalAuthorization-popOutBtn">
                    <div class="ProvisionalAuthorization-saveBtn" @click="Save">{{ $t("system_approvalset_list_baocun") }}</div>
                    <div class="ProvisionalAuthorization-cancelBtn" @click="cancel">{{ $t("system_approvalset_list_quxiaoxiugai") }}</div>
                  </div>
                </ProvisionalAuthorization>
              </div>
            </div>
          </transition>
        </div>
      </transition>
    </div>
  </page-frame>
</template>
<style scoped>

  .ProvisionalAuthorization-Btn {
    padding-top: 0.532rem;
    padding-bottom: 0.798rem;
    margin-left: -0.399rem;
  }

  .ProvisionalAuthorization-Btn > div {
    width: 2.1rem;
    background: linear-gradient(to left, #ff4439, #ff9b39);
    text-align: center;
    margin: 0 auto;
    height: 1.064rem;
    line-height: 1.064rem;
    border-radius: 0.532rem;
    color: #fff;
    box-shadow: 0 0.03rem 0.215rem rgba(255, 89, 57, 0.43);
  }

  .AuthorizationList {
    background-color: #fff;
    border-top-left-radius: 0.266rem;
    border-top-right-radius: 0.266rem;

    height: 1.5rem;
  }

  .AuthorizationList-title {
    background-color: #fff;
    height: 1.33rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.399rem;
    border-top-left-radius: 0.266rem;
    border-top-right-radius: 0.266rem;
  }

  .AuthorizationList-title > span:last-child {
    display: inline-block;
    padding: 0 0.266rem;
    height: 1.33rem;
    line-height: 1.33rem;
    font-size: 0.372rem;
    color: #666;
  }

  .AuthorizationList-wrapper {
    padding-left: 0.399rem;
  }

  .list-wrapper {
    background-color: #fff;
  }

  .AuthorizationList-item {
    position: relative;
    font-size: 0.372rem;
  }

  .AuthorizationList-item > div {
    height: 1.33rem;
    line-height: 1.33rem;
  }

  .AuthorizationList-item > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 1.197rem;
  }

  .AuthorizationList-item > div:nth-child(2) {
    position: absolute;
    top: 0;
    right: 0;
    height: 1.33rem;
    line-height: 1.33rem;
  }

  .AuthorizationList-item .AuthorizationList-tag .isExpiryDate {
    background-color: #e3e3e3;
  }

  .AuthorizationList-tag span {
    width: 1.33rem;
    height: 0.532rem;
    line-height: 0.532rem;
    vertical-align: middle;
    display: inline-block;
  }

  .AuthorizationList-tag span:last-child {
    text-align: center;
    color: #fff;
    background-color: #ff0000;
    font-size: 0.3192rem;
    border-radius: 0.02rem;
  }

  .ProvisionalAuthorization-popOut .picker {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(37, 38, 45, 0.4);
  }

  .ProvisionalAuthorization-popOut .picker-fade-enter,
  .ProvisionalAuthorization-popOut .picker-fade-leave-active {
    opacity: 0;
  }

  .ProvisionalAuthorization-popOut .picker-fade-enter-active,
  .ProvisionalAuthorization-popOut .picker-fade-leave-active {
    transition: all 0.5s ease-in-out;
  }

  .ProvisionalAuthorization-popOut .picker-panel {
    position: absolute;
    z-index: 600;
    bottom: 0;
    width: 100%;
  }

  .ProvisionalAuthorization-popOut .picker-move-enter,
  .ProvisionalAuthorization-popOut .picker-move-leave-active {
    transform: translate3d(0, 7.261rem, 0);
  }

  .ProvisionalAuthorization-popOut .picker-move-enter-active,
  .ProvisionalAuthorization-popOut .picker-move-leave-active {
    transition: all 0.3s ease-in-out;
  }

  .ProvisionalAuthorization-popOutBtn {
    padding: 0.399rem 0.399rem 0.399rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .ProvisionalAuthorization-popOutBtn > div {
    width: 1.7rem;
    text-align: center;
    height: 1.064rem;
    line-height: 1.064rem;
    color: #fff;
    background-color: #ed6e2b;
    border-radius: 0.106rem;
    font-size: 0.425rem;
  }
</style>
<style>
  .ProvisionalAuthorization-popOut .ProvisionalAuthorization-wrapper {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
</style>
<script>
  const STATE_HIDE = 0;
  const STATE_SHOW = 1;
  import popOut from "../modules/pop-out.vue";
  import ProvisionalAuthorization from "./ProvisionalAuthorization.vue";
  import range from "../modules/range.vue";
  import Scroll from "../modules/Scroll.vue";
  import navBar from "../modules/navBar.vue";
  import { RoleType } from "@/model/Base";
  import UserService from "@/service/UserService";
  export default {
    name: "approvalSetList",
    data() {
      return {
        state: STATE_HIDE,
        objSave: {
          centerTitle: "system.ApprovalAccredit",
          rightTitle: "",
        },
        model: {
          OwnerID: "",
          ConferDate: moment().format("YYYY-MM-DD"), //授予日期
          ExpiryDate: moment()
            .add(1, "days")
            .format("YYYY-MM-DD"), //过期日期
          durationType: "hours",
          sliderValue: 10,
          time: moment().hour() < 10 ? 0 + "" + moment().hour() + ":00" : moment().hour() + ":00",
        },
        detailModel: {
          OwnerID: "",
          ConferDate: moment().format("YYYY-MM-DD"), //授予日期
          ExpiryDate: moment()
            .add(1, "days")
            .format("YYYY-MM-DD"), //过期日期
          durationType: "hours",
          sliderValue: 10,
          time: moment().hour() < 10 ? 0 + "" + moment().hour() + ":00" : moment().hour() + ":00",
        },
        lists: [],
        Companys: [],
        ConferID: "",
      };
    },
    computed: {
      CompanyID() {
        return this.profile.CompanyID;
      },
      UserID() {
        return this.profile.UserID;
      },
    },
    created() {
      let __self = this;
      __self.__init();
      __self.getRoleList();
    },
    methods: {
      show() {
        this.state = STATE_SHOW;
      },
      hide() {
        this.state = STATE_HIDE;
      },
      confirm() {
        this.hide();
      },
      cancel() {
        this.hide();
      },
      isExpiryDate(ExpiryDate) {
        let time = moment(ExpiryDate).diff(moment(), "seconds");
        if (time > 0) {
          return false;
        } else {
          return true;
        }
      },
      Save() {
        let __self = this;
        let data = {};
        if (__self.detailModel.OwnerID == "") {
          data = _.cloneDeep(__self.model);
          data.ConferDate = moment(__self.model.ConferDate + " " + __self.model.time).format("YYYY-MM-DD HH:mm");
        } else {
          data = _.cloneDeep(__self.detailModel);
          data.ConferDate = moment(__self.detailModel.ConferDate + " " + __self.detailModel.time).format("YYYY-MM-DD HH:mm");
        }
        data.ExpiryDate = moment(data.ExpiryDate).format("YYYY-MM-DD HH:mm");
        if (data.OwnerID == "") {
          return $utils.fail(this.$root.$t("system_approvalset_list_qingxuanzeshouquanyuangong"), "fail");
        }
        data.ConferID = __self.ConferID;
        if (data.ConferID == "") {
          data.RoleWith = RoleType.User;
          data.OwnerWith = RoleType.User;
          data.RoleID = __self.UserID;
          data.SpaceID = __self.UserID;
        }
        UserService.saveConferInfo(data).then(json => {
          if (json.isSucc) {
            if (__self.detailModel.OwnerID != "") {
              this.$root.$toast.success(__self.$t("share.succ.ModifySucc"));
            } else {
              this.$root.$toast.success(__self.$t("share.succ.AddSucc"));
            }
            __self.state = STATE_HIDE;
            __self.ConferID = "";
            __self.__init();
          }
        });
      },
      __init() {
        let __self = this;
        let data = {
          PageNo: 1,
          PageSize: 999999,
          RecordCount: 0,
          OwnerID: "",
          RoleWith: RoleType.User,
          OwnerWith: RoleType.User,
          RoleID: __self.UserID,
          SpaceID: __self.UserID,
        };
        UserService.getConferList(data).then(json => {
          if (json.isSucc) {
            __self.lists = json.result.entities;
          }
        });
      },
      getRoleList() {
        let __self = this;
        let data = {};
        data.RoleType = RoleType.User;
        data.Superior = {};
        data.Superior.RoleType = RoleType.Department;
        data.Superior.RootID = __self.CompanyID;
        data.PageSize = 99999;
        UserService.getRoleList(data).then(o => {
          __self.Companys = o.result.entities;
        });
      },
      editApprovalSet(ConferID) {
        let __self = this;
        __self.ConferID = ConferID;
        UserService.getConferInfo({
          ConferID: __self.ConferID,
        }).then(o => {
          if (o.isSucc) {
            __self.state = STATE_SHOW;
            let result = o.result;
            if (result) {
              __self.detailModel.OwnerID = result.OwnerID;
              __self.detailModel.ConferDate = moment(result.ConferDate).format("YYYY-MM-DD");
              __self.detailModel.ExpiryDate = result.ExpiryDate;
              __self.detailModel.time = moment(result.ConferDate).format("HH:mm");
            }
            let ExpiryDate = moment(__self.detailModel.ExpiryDate);
            let ConferDate = moment(__self.detailModel.ConferDate);
            let time = ExpiryDate.diff(ConferDate, "hours");
            if (time >= 24) {
              __self.detailModel.durationType = "day";
              __self.detailModel.sliderValue = parseInt(time / 24);
            } else {
              __self.detailModel.durationType = "hours";
              __self.detailModel.sliderValue = time;
            }
          }
        });
      },
      delectApprovalSet(ConferID) {
        let __self = this;
        let data = {
          ConferID: ConferID,
        };
        UserService.deleteConferInfo(data).then(o => {
          if (o.isSucc) {
            this.$root.$toast.success(__self.$t("share.succ.DeleteSucc"));
            __self.__init();
          }
        });
      },
      clearExpiryDate() {
        let __self = this;
        __self.lists.forEach(list => {
          let result = __self.isExpiryDate(list.ExpiryDate);
          if (result) {
            let data = {
              ConferID: list.ConferID,
            };
            UserService.deleteConferInfo(data).then(o => {
              if (o.isSucc) {
                this.$root.$toast.success(__self.$t("share.succ.DeleteSucc"));
                __self.__init();
              }
            });
          }
        });
      },
      back() {
        history.back();
      },
    },
    components: {
      navBar,
      Scroll,
      range,
      ProvisionalAuthorization,
      popOut,
    },
  };
</script>
